<template>
  <section class="home-bed">
    <div class="img-bed">
      <back-bar title="武汉通SIM交通卡" :showMore="barShowMore" :canGoHome="true"></back-bar>
    </div>
    <bar-list :funcClicked="barListClicked" :show="showMoreList" :list="['操作说明','用户协议','待充值订单']"></bar-list>
    <div class="card-box">
      <img src="../assets/img/noAccess/img_card.png">
      <span class="cardName">武汉通SIM交通卡</span>
      <span class="cardId">卡号：{{cardInfo.printNo}}</span>
      <div class="balace">
        <span class="key">余额(元):</span>
        <span class="val">{{cardInfo.balance/100}}</span>
      </div>
      <div class="cardBtn"
           @click.stop="copy">复制卡号</div>
    </div>
    <div class="operation">
      <div class="li"
           @click="goRouter('orderList')"> <img src="../assets/img/noAccess/icon_list.png">
        <span>交易记录</span>
      </div>
      <div class="li"
           @click="goRouter('questiones')">
        <img src="../assets/img/noAccess/icon_normal.png">
        <span>常见问题</span>
      </div>

    </div>
    <div class="word">
      <span>说明：</span>
      <span>1.手机具有NFC功能且可选择SIM卡通道</span>
      <span>2.需要使用移动的超级SIM卡（NFC-SIM卡）和放SIM1卡槽</span>
      <span>3.刷卡时，系统的NFC默认付款设置为SIM卡</span>
    </div>
    <div class="btn"
         @click="rechargeBtnClicked">
      充值
    </div>

  </section>
</template>

<script>
import backBar from '@/components/backBar'
import barList from '../components/barList.vue'
export default {
  name: 'payIndex',
  data () {
    return {
      loading: true,
      cardInfo: {

      },
      showMoreList: false,//右上角菜单是否显示
    }
  },
  components: {
    backBar,
    barList
  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  mounted () {
    const that = this;
    window.cardStatus = that.cardStatus;
  },



  methods: {
    barListClicked (index) {
      console.log('index===',index)
      this.showMoreList = false
      if (index == 0) {
        this.$router.push({
          name: 'useWord'
        })
      }else if (index == 1) {
        this.$router.push({
          name: 'protocol'
        })
      }else if (index == 2) {//待充值订单
        this.$router.push({
          name: 'payWaitList'
        })
      }
    },
    barShowMore () {
      this.showMoreList = !this.showMoreList
    },
    copy () {
      let oInput = document.createElement("input");
      oInput.value = this.cardInfo.printNo;
      document.body.appendChild(oInput);
      oInput.select();
      console.log(oInput.value);
      document.execCommand("Copy");
      oInput.remove();
      this.$eventBus.$emit('getTipsInfo', {
        msg: '卡号复制成功'
      })
    },
    cardStatus (cardInfo) {
      if (cardInfo.code == '0000') {
        this.cardInfo = cardInfo.data;
      } else {
        this.$eventBus.$emit('getTipsInfo', {
          msg: cardInfo.message
        })
      }
    },
    goRouter (router) {
      if (this.loading) {
        this.$router.push({
          name: router,
          params: { cardInfo: this.cardInfo }
        })
      }
    },
    rechargeBtnClicked() {//向app发送消息，不直接跳转
      window.android.clickRecharge(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  overflow: scroll;
  position: relative;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  height: 320px;
  background-image: url(../assets/img/noAccess/img_top.png);
  background-repeat: no-repeat;
  background-size: cover;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
  img {
    width: 100%;
  }
}
.card-box {
  width: 92%;
  position: absolute;
  top: 110px;
  margin-left: 4%;
  img {
    width: 100%;
  }
  .cardName {
    position: absolute;
    left: 32px;
    top: 38%;
    font-size: 40px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9019607843137255);
  }
  .cardId {
    position: absolute;
    right: 39px;
    top: 28px;
    font-size: 26px;
    font-weight: 400;
    color: #ffffff;
  }
  .balace {
    position: absolute;
    left: 32px;
    top: calc(38% + 80px);
    width: 80%;
    display: flex;
    flex-direction: column;
    .key {
      line-height: 30px;
      font-size: 24px;
      font-family: 宋体;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
    }
    .val {
      line-height: 78px;
      font-size: 56px;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .cardBtn {
    position: absolute;
    right: 32px;
    top: 50%;
    width: 160px;
    height: 64px;
    margin-top: -32px;
    // line-height: 64px;
    background: #ffffff;
    box-shadow: 0px 6px 20px 1px rgba(0, 136, 255, 0.2);
    border-radius: 36px 36px 36px 36px;
    opacity: 1;
    font-size: 28px;
    font-weight: 400;
    color: #4a8ef7;
    // text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
  width: 92%;
  position: absolute;
  top: 460px;
  margin-left: 4%;
  display: flex;
  // flex-direction: column;
  justify-content: center;
  align-items: center;
  .li {
    display: flex;
    flex-direction: column;
    width: 50%;
    justify-content: center;
    align-items: center;
    img {
      width: 64px;
      height: 64px;
    }
    span {
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      margin-top: 16px;
    }
  }
}
.word {
  width: 92%;
  position: absolute;
  top: 620px;
  margin-left: 4%;
  display: flex;
  flex-direction: column;
  span {
    font-size: 24px;
    font-weight: 400;
    color: #999999;
    line-height: 40px;
  }
}
.btn {
  position: absolute;
  bottom: 80px;
  width: 92%;
  height: 98px;
  line-height: 98px;
  margin-left: 4%;
  background: #4a8ef7;
  box-shadow: 0px 6px 20px 1px rgba(63, 138, 247, 0.2);
  border-radius: 49px 49px 49px 49px;
  text-align: center;
  font-size: 32px;
  font-weight: 400;
  color: #ffffff;
}
</style>
